import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const allowed = this.authService.sessionData.pipe(
            map((data) => {
                if (data.isLoggedIn && data.user.expires > Date.now()) {
                    return true;
                }

                const returnUrl = this.getReturnUrlForDrawerQueryOrDefault(route, state);

                this.router.navigate(['/login'], { queryParams: { returnUrl: returnUrl } });
                this.authService.expired();
                return false;
            })
        );

        return allowed;
    }

    /**
     * when opening a page with a query from a new tab etc. the auth guard checks if loggedIn
     * and then redirects if not loggedIn but the problem is:
     *  - route.url does not contain the query so it gets removed
     *  - the on first init the authGuard gets called twice, first before and second after initLoad -> first sessionData is empty -> redirect to login
     * in order to not break anything the function looks only for the query needed for this task
     * otherwise as normal
     */
    getReturnUrlForDrawerQueryOrDefault(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
        if (!!route.queryParams['openDrawer']) return state.url;
        return this.buildUrlFromSegments(route.url);
    }

    buildUrlFromSegments(segments: UrlSegment[]): string {
        return segments.map((segment) => segment.path).join('/');
    }
}
